import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AddCommentService {
  private readonly http = inject(HttpClient);

  commentCrud(url: string, params: Record<string, any>): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    const body = new URLSearchParams();
    Object.keys(params).forEach((key) => {
      const value = params[key];
      if (value !== undefined && value !== null) {
        body.set(key, typeof value === 'object' ? JSON.stringify(value) : String(value));
      }
    });
    return this.http.post<any>(url, body.toString(), { headers, withCredentials: true });
  }

  getTagsList(baseUrl: string): Observable<any> {
    return this.http.get<any>(`${baseUrl}/getTagsList`, { withCredentials: true });
  }

  saveTag(baseUrl: string, tagName: string, tagDesc: string): Observable<any> {
    return this.commentCrud(`${baseUrl}/saveNewTag`, { tag_name: tagName, tag_desc: tagDesc });
  }

  searchUsers(baseUrl: string, searchString: string): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    const body = new URLSearchParams();
    body.set('action_id', '76');
    body.set('search_string', searchString);
    return this.http.post<any>(`${baseUrl}/loadJsonObject`, body.toString(), { headers, withCredentials: true });
  }

  getUploadUrl(baseUrl: string): string {
    return `${baseUrl}/uploadCommentAttachements`;
  }

  removeAttachment(baseUrl: string, fileName: string): Observable<any> {
    return this.commentCrud(`${baseUrl}/removeAttachment`, { destDir: 'temp', flowFilename: fileName });
  }
}
